module.exports = ".bold\r\n{\r\n    font-weight: 900;\r\n}"